/*
 * SnapEngage Module:
 * Initialize SnapEngage script "as needed"
 */

// modified version of SnapEngage script to load "as needed"
/* eslint-disable func-names, prefer-rest-params */
const initSnapEngage = (isOs) => {
  let se = document.createElement('script')
  se.type = 'text/javascript'
  se.async = true
  if (isOs) {
    se.src = 'https://storage.googleapis.com/code.snapengage.com/js/703bc91a-9f57-466d-9600-b18b8613dbb3.js'
  } else {
    se.src = 'https://storage.googleapis.com/code.snapengage.com/js/9c5825ac-87b6-4632-9c85-c77c609c94e1.js'
  }
  let done = false
  se.onload = se.onreadystatechange = function () {
    if (!done&&(!this.readyState||this.readyState==='loaded'||this.readyState==='complete')) {
      done = true
      /* Place your SnapEngage JS API code below */
      /* SnapEngage.allowChatSound(true); Example JS API: Enable sounds for Visitors. */
    }
  }
  // Disabled snap-engage, refer to SATURN-2804
  // let s = document.getElementsByTagName('script')[0]
  // s.parentNode.insertBefore(se, s)
}

/* eslint-enable func-names, prefer-rest-params */

export default function bootSnapEngage (isOs = false) {
  initSnapEngage(isOs)
}
